import APIService from "@/services/APIService.js";

const apiDepartamentos = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/departamento"
});

export default {
  getAll(limit, page, filters) {
    return apiDepartamentos.get("", {
      params: {
        limit: limit,
        offset: page * limit - limit,
        sort_by: "nome",
        ...filters
      }
    });
  },
  update(id, departamento) {
    return apiDepartamentos.put("/" + id, departamento);
  },
  create(departamento) {
    return apiDepartamentos.post("", departamento);
  }
};
